/**
 * @flow
 * @format
 */

import _StepWrapper from './StepWrapper';

export default _StepWrapper;



// WEBPACK FOOTER //
// ./src/components/StepWrapper/index.js